interface Question {
    imgUrl: string;
    questionText?: string;
    answers: {
        answerImgUrl: string;
        answerText?: string;
    }[];
}

const preloadImages = (questionList: Question[]) => {
    const imageRegex = /(https?:\/\/.*\.(?:png|jpg|jpeg|gif|svg|webp))/gi;

    questionList.forEach((question) => {
        // Preload question image URL
        if (question.imgUrl) {
            const img = new Image();
            img.src = question.imgUrl;
        }

        //Preload images in helptext
        if (question.helpText) {
            const questionImages = question.helpText.match(imageRegex);
            if (questionImages) {
                questionImages.forEach((imgUrl) => {
                    const img = new Image();
                    img.src = imgUrl;
                });
            }
        }

        // Preload images in question text
        if (question.questionText) {
            const questionImages = question.questionText.match(imageRegex);
            if (questionImages) {
                questionImages.forEach((imgUrl) => {
                    const img = new Image();
                    img.src = imgUrl;
                });
            }
        }

        // Preload answer images
        question.answers.forEach((answer) => {
            if (answer.answerImgUrl) {
                const img = new Image();
                img.src = answer.answerImgUrl;
            }

            // Preload images in answer text
            if (answer.answerText) {
                const answerImages = answer.answerText.match(imageRegex);
                if (answerImages) {
                    answerImages.forEach((imgUrl) => {
                        const img = new Image();
                        img.src = imgUrl;
                    });
                }
            }
        });
    });
}

export default preloadImages;